import classNames from "./Slider.module.css";
import * as RadixSlider from "@radix-ui/react-slider";

const Slider = (props: {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  label: string;
}) => {
  return (
    <RadixSlider.Root
      className={classNames.SliderRoot}
      min={props.min}
      max={props.max}
      step={1}
      value={[props.value]}
      onValueChange={(value) => props.onChange(value[0])}
    >
      <RadixSlider.Track className={classNames.SliderTrack}>
        <RadixSlider.Range className={classNames.SliderRange} />
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className={classNames.SliderThumb}
        aria-label={props.label}
      />
    </RadixSlider.Root>
  );
};

export default Slider;
